import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import FieldInput from '../../form/FieldInput';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	NEXT,
	ONBOARDING_COMPLETE_NAME_TITLE,
	ONBOARDING_COMPLETE_FIRSTNAME,
	ONBOARDING_COMPLETE_LASTNAME,
} from '../../../../constants/Copy';
import * as validators from '../../form/validators';
import focusDelay from '../../helpers/focusDelay';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';

const RegisterName = ({ submitting, invalid, pristine, handleSubmit }) => {
	let firstName = null;

	useEffect(() => {
		focusDelay(firstName, false);
	}, [firstName]);

	return (
		<form method="POST" onSubmit={handleSubmit}>
			<OnboardingProgress activeStep={2} />
			<Heading>{ONBOARDING_COMPLETE_NAME_TITLE}</Heading>

			<Field
				name="firstName"
				element={(element) => (firstName = element)}
				type="text"
				testId="firstname-input"
				component={FieldInput}
				label={ONBOARDING_COMPLETE_FIRSTNAME}
			/>

			<Field
				name="lastName"
				type="text"
				testId="lastname-input"
				component={FieldInput}
				label={ONBOARDING_COMPLETE_LASTNAME}
			/>

			<Button
				className="onboarding-button"
				loading={submitting}
				disabled={invalid || pristine}
				type="submit"
				testId="name-button"
			>
				{NEXT}
			</Button>
		</form>
	);
};

PropTypes.RegisterName = {
	handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
	form: 'register',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: validators.validateNames,
})(RegisterName);
